import React from "react";
import classnames from "classnames";
import IntlMessages from "../../../utils/messages";

interface BadgeProps {
  label?: string;
  className?: string;
  bgClassName?: string;
  textClassName?: string;
  dataCy?: string;
  children?: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  label,
  className,
  bgClassName = "bg-red-500",
  textClassName = "text-white",
  dataCy,
  children,
}) => {
  const classes = classnames(
    className,
    bgClassName,
    textClassName,
    "py-0.5 px-3 text-xs leading-4 rounded-full transition ease-in-out duration-150"
  );

  const content = label ? <IntlMessages id={label} /> : children;

  return (
    <span className={classes} data-cy={dataCy}>
      {content}
    </span>
  );
};

export default Badge;
